export interface IImageData {
  IdPreinspeccion: number;
  ImageUrl: string;
  Description: string;
  ImageSectionId: number;
  ImageSource: string;
}

export enum PhotoSection {
  PANORAMIC = 1, // Panoramica
  INSURED_VEHICLE = 2, // VehiculoAsegurado
  INSURED_DOCUMENTS = 3, // DocumentosAsegurado
  COUNTERPARTS = 4, // Terceros
  COUNTERPARTS_DOCUMENTS = 5, // DocumentosTerceros
  OTHERS = 6, // Otras
  INJURED_LICENSE = 8,
  INJURED_VEHICLE_LICENSE = 9,
  INJURED_ODOMETER = 10,
  INJURED_MARBETE = 11,
  INJURED_VIN = 12,
  INJURED_TABLILLA = 13,
  INJURED_VEH_PHOTOS = 14,
  INJURED_VEH_DAMAGE_PHOTOS = 15,
  INJURED_VEH_PANORAMIC = 16,
  INJURED_OTHERS_DOCS = 17,
  RESOLUTION = 18,
  VEHICLE_VIDEO = 19,
  INSURED_LICENSE = 20,
  INSURED_VEHICLE_LICENSE = 21,
  INSURED_ODOMETER = 22,
  INSURED_MARBETE = 23,
  INSURED_VIN = 24,
  INSURED_TABLILLA = 25,
  INSURED_VEH_PHOTOS = 26,
  INSURED_VEH_DAMAGE_PHOTOS = 27,
  INSURED_VEH_PANORAMIC = 28,
  INSURED_OTHERS_DOCS = 29,
  DRIVER_LICENSE_BACK = 30,
  DRIVER_LICENSE_FRONT = 31, // Licencia de conducir (Frontal) - CM-692
  PREINSPECT_DOCS = 43,
  DETAIL_ESTIMATED = 80,
  CMT_DOCUMENTS = 81,
  LEGAL_ASSISTANCE = 82,
  RUV = 83, //Registro Único de Propiedad Vehicular
  INSURED_VEHICLE_VIDEO = 84,
  INSURED_ADDITIONAL_DRIVER_LICENSE = 101,
  INSURED_BANK_STATEMENT = 102,
  INSURED_BILL_OF_SALE = 103,
  INSURED_BIRTH_CERTIFICATE = 104,
  INJURED_ADDITIONAL_DRIVER_LICENSE = 105,
  INJURED_BANK_STATEMENT = 106,
  INJURED_BILL_OF_SALE = 107,
  INJURED_BIRTH_CERTIFICATE = 108,
  INSURED_VEH_FRONTSIDE_PHOTO = 109,
  INSURED_VEH_REARSIDE_PHOTO = 110,
  INSURED_VEH_LEFT_SIDE_PHOTO = 111,
  INSURED_VEH_RIGHT_SIDE_PHOTO = 112,
  INJURED_VEH_FRONTSIDE_PHOTO = 113,
  INJURED_VEH_REARSIDE_PHOTO = 114,
  INJURED_VEH_LEFT_SIDE_PHOTO = 115,
  INJURED_VEH_RIGHT_SIDE_PHOTO = 116,
  INSURED_VEH_HOOD_PHOTO = 117,
  INSURED_VEH_TRUNK_PHOTO = 118,
  INSURED_VEH_INTERIOR_PHOTOS = 119,
  INSURED_ADDITIONAL_DOCS = 120,
  INJURED_VEH_HOOD_PHOTO = 121,
  INJURED_VEH_TRUNK_PHOTO = 122,
  INJURED_VEH_INTERIOR_PHOTOS = 123,
  INJURED_ADDITIONAL_DOCS = 124,
  POLICE_TICKET = 126,
  LEGAL_POWER = 127,
}

export enum MediaSection {
  VEHICLE_EXTERIOR = 40,
  VEHICLE_INTERIOR = 41,
  VEHICLE_VIDEO = 42,
  DOCUMENTS = 43,
  RUV = 83,
  ACCESSORIES = 84,
}

export enum MediaId {
  VEHICLE_EXTERIOR_PLATE = 'VEHICLE_EXTERIOR_PLATE',
  VEHICLE_EXTERIOR_FRONT = 'VEHICLE_EXTERIOR_FRONT',
  VEHICLE_EXTERIOR_RIGHT = 'VEHICLE_EXTERIOR_RIGHT',
  VEHICLE_EXTERIOR_BACK = 'VEHICLE_EXTERIOR_BACK',
  VEHICLE_EXTERIOR_LEFT = 'VEHICLE_EXTERIOR_LEFT',

  VEHICLE_INTERIOR_ODOMETER = 'VEHICLE_INTERIOR_ODOMETER',
  VEHICLE_INTERIOR_VIN = 'VEHICLE_INTERIOR_VIN',
  VEHICLE_INTERIOR_1 = 'VEHICLE_INTERIOR_1',
  VEHICLE_INTERIOR_2 = 'VEHICLE_INTERIOR_2',

  VEHICLE_VIDEO = 'VEHICLE_VIDEO',

  DOCUMENTS_VEHICLE_PROPERTY_REGISTRY = 'DOCUMENTS_VEHICLE_PROPERTY_REGISTRY',
  DOCUMENTS_CEDULA = 'DOCUMENTS_CEDULA',
  DOCUMENTS_DRIVERS_LICENSE = 'DOCUMENTS_DRIVERS_LICENSE',
}

export type Section = PhotoSection | MediaSection;

export interface EventPhoto {
  dataURL: string;
  awsUrl?: string;
  claimId?: string;
  imageId?: string | number;
  imageName?: string;
  section: Section;
  mlResults?: string;
  cpeCategory?: string;
  imageType?: string;
  order?: number;
  location?: string;
  isWaiting?: boolean;
  orientation?: any;
  icon?: string;
  inputRef?: any;
  coInspectionUpload?: string;
  urlUpload?: string;
  expenseDocument?: string;
  estimatedMitchellDocument?: string;
  lastModified?: Date;
  rotate?: number;
  hasError?: boolean;
}

export interface SectionType {
  section: Section;
  description: string;
  type?: string; // Additional type (like 'insured' or 'injured')
  photos?: EventPhoto[];
  allowsMultiple?: boolean; // If multiple photos are allowed
}

export interface SectionGroup {
  name: string;
  default: SectionType[];
  preInspections?: SectionType[];
  preInspectionsBcr?: SectionType[];
  fedpa?: SectionType[];
  acerta?: SectionType[];
}

export const SectionTypes: Record<string, SectionGroup> = {
  CRC: {
    name: 'CRC',
    default: [
      {
        section: PhotoSection.PANORAMIC,
        description: 'Panorámica Lugar del Evento',
      },
      {
        section: PhotoSection.INSURED_VEHICLE,
        description: 'Vehículo Asegurado',
      },
      {
        section: PhotoSection.INSURED_DOCUMENTS,
        description: 'Documentos de Asegurado',
      },
      {
        section: PhotoSection.COUNTERPARTS,
        description: 'Terceros',
      },
      {
        section: PhotoSection.COUNTERPARTS_DOCUMENTS,
        description: 'Documentos de Terceros',
      },
      {
        section: PhotoSection.OTHERS,
        description: 'Otros Documentos',
      },
      {
        section: PhotoSection.VEHICLE_VIDEO,
        description: 'Video 360°',
      },
    ],
    preInspections: [
      {
        section: MediaSection.VEHICLE_EXTERIOR,
        description: 'Exterior del Vehículo',
      },
      {
        section: MediaSection.VEHICLE_INTERIOR,
        description: 'Interior del Vehículo',
      },
      {
        section: MediaSection.ACCESSORIES,
        description: 'Accesorios',
      },
      {
        section: MediaSection.VEHICLE_VIDEO,
        description: 'Video 360°',
      },
      {
        section: MediaSection.DOCUMENTS,
        description: 'Documentos',
      },
    ],
    preInspectionsBcr: [
      {
        section: MediaSection.VEHICLE_EXTERIOR,
        description: 'Exterior del Vehículo',
      },
      {
        section: MediaSection.VEHICLE_INTERIOR,
        description: 'Interior del Vehículo',
      },
      {
        section: MediaSection.ACCESSORIES,
        description: 'Accesorios',
      },
      {
        section: MediaSection.DOCUMENTS,
        description: 'Documentos',
      },
    ],
  },
  PAN: {
    name: 'PAN',
    default: [
      {
        section: PhotoSection.DRIVER_LICENSE_FRONT,
        description: 'Licencia de conducir (Frontal)',
      },
      {
        section: PhotoSection.DRIVER_LICENSE_BACK,
        description: 'Licencia de conducir (Trasera)',
      },
      {
        section: PhotoSection.RUV,
        description: 'Registro Único Vehicular',
      },
      {
        section: PhotoSection.PANORAMIC,
        description: 'Foto Panorámica',
      },
      {
        section: PhotoSection.INSURED_VEHICLE,
        description: 'Vehículo Asegurado',
      },
      {
        section: PhotoSection.INSURED_DOCUMENTS,
        description: 'Documentos de Asegurado',
      },
      {
        section: PhotoSection.INSURED_VEH_FRONTSIDE_PHOTO,
        description: 'Foto Frontal (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_LEFT_SIDE_PHOTO,
        description: 'Foto Lateral Izquierda (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_RIGHT_SIDE_PHOTO,
        description: 'Foto Lateral Derecha (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_REARSIDE_PHOTO,
        description: 'Foto Trasera (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_TABLILLA,
        description: 'Placa (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VIN,
        description: 'VIN / Chasis (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_ODOMETER,
        description: 'Odómetro (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.COUNTERPARTS,
        description: 'Terceros',
      },
      {
        section: PhotoSection.COUNTERPARTS_DOCUMENTS,
        description: 'Documentos de Terceros',
      },
      {
        section: PhotoSection.OTHERS,
        description: 'Otros Documentos',
      },
      {
        section: PhotoSection.VEHICLE_VIDEO,
        description: 'Video 360°',
      },
    ],
    fedpa: [
      {
        section: PhotoSection.DRIVER_LICENSE_FRONT,
        description: 'Licencia de conducir (Frontal)',
      },
      {
        section: PhotoSection.DRIVER_LICENSE_BACK,
        description: 'Licencia de conducir (Trasera)',
      },
      {
        section: PhotoSection.RUV,
        description: 'Registro Único Vehicular',
      },
      {
        section: PhotoSection.PANORAMIC,
        description: 'Foto Panorámica',
      },
      {
        section: PhotoSection.INSURED_VEHICLE,
        description: 'Vehículo Asegurado',
      },
      {
        section: PhotoSection.INSURED_DOCUMENTS,
        description: 'Documentos de Asegurado',
      },
      {
        section: PhotoSection.INSURED_VEH_FRONTSIDE_PHOTO,
        description: 'Foto Frontal (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_LEFT_SIDE_PHOTO,
        description: 'Foto Lateral Izquierda (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_RIGHT_SIDE_PHOTO,
        description: 'Foto Lateral Derecha (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_REARSIDE_PHOTO,
        description: 'Foto Trasera (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_TABLILLA,
        description: 'Placa (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VIN,
        description: 'VIN / Chasis (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_ODOMETER,
        description: 'Odómetro (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.COUNTERPARTS,
        description: 'Terceros',
      },
      {
        section: PhotoSection.COUNTERPARTS_DOCUMENTS,
        description: 'Documentos de Terceros',
      },
      {
        section: PhotoSection.OTHERS,
        description: 'Otros Documentos',
      },
      {
        section: PhotoSection.VEHICLE_VIDEO,
        description: 'Video 360°',
      },
      {
        section: PhotoSection.LEGAL_ASSISTANCE,
        description: 'Asistencia Legal',
      },
    ],
    preInspections: [
      {
        section: MediaSection.VEHICLE_EXTERIOR,
        description: 'Exterior del Vehículo',
      },
      {
        section: MediaSection.VEHICLE_INTERIOR,
        description: 'Interior del Vehículo',
      },
      {
        section: MediaSection.VEHICLE_VIDEO,
        description: 'Video 360°',
      },
      {
        section: MediaSection.DOCUMENTS,
        description: 'Documentos',
      },
    ],
  },
  PRI: {
    name: 'PRI',
    default: [
      {
        section: PhotoSection.INSURED_LICENSE,
        type: 'insured',
        description: 'Licencia Conducir (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEHICLE_LICENSE,
        type: 'insured',
        description: 'Licencia Vehículo (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_ADDITIONAL_DRIVER_LICENSE,
        type: 'insured',
        description: 'Licencia Adicional Conducir (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_BANK_STATEMENT,
        type: 'insured',
        description: 'Estado Cuenta Bancaria (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_BILL_OF_SALE,
        type: 'insured',
        description: 'Contrato Compra-Venta (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_BIRTH_CERTIFICATE,
        type: 'insured',
        description: 'Certificado Nacimiento (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_MARBETE,
        type: 'insured',
        description: 'Marbete (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VIN,
        type: 'insured',
        description: 'VIN / Chasis (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_ODOMETER,
        type: 'insured',
        description: 'Odómetro (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_TABLILLA,
        type: 'insured',
        description: 'Tablilla (Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_FRONTSIDE_PHOTO,
        type: 'insured',
        description: 'Foto Frontal (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_REARSIDE_PHOTO,
        type: 'insured',
        description: 'Foto Trasera (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_LEFT_SIDE_PHOTO,
        type: 'insured',
        description: 'Foto Lateral Izquierda (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_RIGHT_SIDE_PHOTO,
        type: 'insured',
        description: 'Foto Lateral Derecha (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_INTERIOR_PHOTOS,
        type: 'insured',
        description: 'Interior (Vehículo Asegurado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INSURED_VEH_HOOD_PHOTO,
        type: 'insured',
        description: 'Bonete (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_TRUNK_PHOTO,
        type: 'insured',
        description: 'Baúl (Vehículo Asegurado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEH_PHOTOS,
        type: 'insured',
        description: 'Vehículo (Laterales, Frontal y Trasera) de Asegurado',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INSURED_ADDITIONAL_DOCS,
        type: 'insured',
        description: 'Documentos Adicionales (Asegurado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INSURED_VEH_DAMAGE_PHOTOS,
        type: 'insured',
        description: 'Daños (Vehículo Asegurado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INSURED_VEH_PANORAMIC,
        type: 'insured',
        description: 'Panorámica (Vehículo Asegurado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INSURED_OTHERS_DOCS,
        type: 'insured',
        description: 'Otros (Asegurado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INJURED_LICENSE,
        type: 'injured',
        description: 'Licencia de Conducir (Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VEHICLE_LICENSE,
        type: 'injured',
        description: 'Licencia de Vehículo (Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_ADDITIONAL_DRIVER_LICENSE,
        type: 'injured',
        description: 'Licencia Adicional de Conducir (Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_BANK_STATEMENT,
        type: 'injured',
        description: 'Estado Cuenta Bancaria (Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_BILL_OF_SALE,
        type: 'injured',
        description: 'Contrato Compra-Venta (Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_BIRTH_CERTIFICATE,
        type: 'injured',
        description: 'Certificado Nacimiento (Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_MARBETE,
        type: 'injured',
        description: 'Marbete (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VIN,
        type: 'injured',
        description: 'VIN / Chasis (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_ODOMETER,
        type: 'injured',
        description: 'Odómetro (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_TABLILLA,
        type: 'injured',
        description: 'Tablilla (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VEH_FRONTSIDE_PHOTO,
        type: 'injured',
        description: 'Foto Frontal (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VEH_REARSIDE_PHOTO,
        type: 'injured',
        description: 'Foto Trasera (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VEH_LEFT_SIDE_PHOTO,
        type: 'injured',
        description: 'Foto Lateral Izquierda (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VEH_RIGHT_SIDE_PHOTO,
        type: 'injured',
        description: 'Foto Lateral Derecha (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VEH_INTERIOR_PHOTOS,
        type: 'injured',
        description: 'Interior (Vehículo Perjudicado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INJURED_VEH_HOOD_PHOTO,
        type: 'injured',
        description: 'Bonete (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VEH_TRUNK_PHOTO,
        type: 'injured',
        description: 'Baúl (Vehículo Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INJURED_VEH_PHOTOS,
        type: 'injured',
        description: 'Vehículo (Laterales, Frontal y Trasera) de Perjudicado',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INJURED_ADDITIONAL_DOCS,
        type: 'injured',
        description: 'Documentos Adicionales (Perjudicado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INJURED_VEH_DAMAGE_PHOTOS,
        type: 'injured',
        description: 'Daños (Vehículo Perjudicado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INJURED_VEH_PANORAMIC,
        type: 'injured',
        description: 'Panorámica (Vehículo Perjudicado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.INJURED_OTHERS_DOCS,
        type: 'injured',
        description: 'Otros (Perjudicado)',
        allowsMultiple: true,
      },
      {
        section: PhotoSection.VEHICLE_VIDEO,
        type: 'injured',
        description: 'Video 360° (Perjudicado)',
        allowsMultiple: false,
      },
      {
        section: PhotoSection.INSURED_VEHICLE_VIDEO,
        type: 'insured',
        description: 'Video 360° (Asegurado)',
        allowsMultiple: false,
      },
    ],
  },
};

export const claimFileSections = [
  {
    sectionName: '20_INSURED_LICENSE',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '21_INSURED_VEHICLE_LICENSE',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '22_INSURED_ODOMETER',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '23_INSURED_MARBETE',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '24_INSURED_VIN',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '25_INSURED_TABLILLA',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '26_INSURED_VEH_PHOTOS',
    description: 'Fotos del Vehículo',
  },
  {
    sectionName: '109_INSURED_VEH_FRONTSIDE_PHOTO',
    description: 'Foto Frontal (Vehículo Asegurado)',
  },
  {
    sectionName: '110_INSURED_VEH_REARSIDE_PHOTO',
    description: 'Foto Trasera (Vehículo Asegurado)',
  },
  {
    sectionName: '111_INSURED_VEH_LEFT_SIDE_PHOTO',
    description: 'Foto Lateral Izquierda (Vehículo Asegurado)',
  },
  {
    sectionName: '112_INSURED_VEH_RIGHT_SIDE_PHOTO',
    description: 'Foto Lateral Derecha (Vehículo Asegurado)',
  },
  {
    sectionName: '27_INSURED_VEH_DAMAGE_PHOTOS',
    description: 'Fotos de Daños (Vehículo)',
  },
  {
    sectionName: '28_INSURED_VEH_PANORAMIC',
    description: 'Panorámica (Vehículo)',
  },
  {
    sectionName: '29_INSURED_OTHERS_DOCS',
    description: 'Otros Archivos',
  },
  {
    sectionName: '8_INJURED_LICENSE',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '9_INJURED_VEHICLE_LICENSE',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '10_INJURED_ODOMETER',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '11_INJURED_MARBETE',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '12_INJURED_VIN',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '13_INJURED_TABLILLA',
    description: 'Información del Vehículo',
  },
  {
    sectionName: '14_INJURED_VEH_PHOTOS',
    description: 'Fotos del Vehículo',
  },
  {
    sectionName: '113_INJURED_VEH_FRONTSIDE_PHOTO',
    description: 'Foto Frontal (Vehículo Perjudicado)',
  },
  {
    sectionName: '114_INJURED_VEH_REARSIDE_PHOTO',
    description: 'Foto Trasera (Vehículo Perjudicado)',
  },
  {
    sectionName: '115_INJURED_VEH_LEFT_SIDE_PHOTO',
    description: 'Foto Lateral Izquierda (Vehículo Perjudicado)',
  },
  {
    sectionName: '116_INJURED_VEH_RIGHT_SIDE_PHOTO',
    description: 'Foto Lateral Derecha (Vehículo Perjudicado)',
  },
  {
    sectionName: '15_INJURED_VEH_DAMAGE_PHOTOS',
    description: 'Fotos de Daños (Vehículo)',
  },
  {
    sectionName: '16_INJURED_VEH_PANORAMIC',
    description: 'Panorámica (Vehículo)',
  },
  {
    sectionName: '17_INJURED_OTHERS_DOCS',
    description: 'Otros Archivos',
  },
  {
    sectionName: 'CT_OTHERS',
    description: 'Otros Archivos',
  },
  {
    sectionName: '121_INJURED_VEH_HOOD_PHOTO',
    description: 'Bonete de Perjudicado',
  },
  {
    sectionName: '122_INJURED_VEH_TRUNK_PHOTO',
    description: 'Baúl de Perjudicado',
  },
  {
    sectionName: '123_INJURED_VEH_INTERIOR_PHOTOS',
    description: 'Interior del vehículo de Perjudicado',
  },
  {
    sectionName: '124_INJURED_ADDITIONAL_DOCS',
    description: 'Documentos adicionales de Perjudicado',
  },
  {
    sectionName: '117_INSURED_VEH_HOOD_PHOTO',
    description: 'Bonete de Asegurado',
  },
  {
    sectionName: '118_INSURED_VEH_TRUNK_PHOTO',
    description: 'Baúl de Asegurado',
  },
  {
    sectionName: '119_INSURED_VEH_INTERIOR_PHOTOS',
    description: 'Interior del vehículo de Asegurado',
  },
  {
    sectionName: '120_INSURED_ADDITIONAL_DOCS',
    description: 'Documentos adicionales de Asegurado',
  },
];

export interface IForceImage {
  id: PhotoSection;
  photoData: string;
}

export interface IPhotoSectionError {
  id: PhotoSection;
  filePhoto: File;
}
